import { render, staticRenderFns } from "./homeTemplates.vue?vue&type=template&id=bc4ec41c&scoped=true"
import script from "./homeTemplates.vue?vue&type=script&lang=js"
export * from "./homeTemplates.vue?vue&type=script&lang=js"
import style0 from "./homeTemplates.vue?vue&type=style&index=0&id=bc4ec41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4ec41c",
  null
  
)

export default component.exports